import BinIcon from "../../../../components/icon/Icon";
import { useLangContext } from "../../../../providers/LangProvider/LangProviderContext";
import { useConvertIntervalsToLocalString } from "../../../../modules/Asset/hooks/useConvertIntervalsToLocalString";
import { MobilePositionUnavailableStyled } from "../styled/MobilePositionStyled";
import useSecondsCountdown from '../../../../hooks/useSecondsCountdown';
import { memo } from 'react';

interface IMobilePositionInactiveWrapperProps {
    children: JSX.Element | JSX.Element[],
    className?: string,
    clickAssetScheduleHandler?: (e: any) => void,
    timeToBidding: number,
}

const MobilePositionInactiveWrapper = (props: IMobilePositionInactiveWrapperProps) => {
    const {
        timeToBidding: timeToBiddingProperty,
        clickAssetScheduleHandler = () => {
        },
        children,
        className,
    } = props;

    const { getLangPath } = useLangContext();
    const [intervalsToLocalString] = useConvertIntervalsToLocalString();
    const { secondsLeft } = useSecondsCountdown({ initialSecondsLeft: Math.round(timeToBiddingProperty / 1000) });

    if (secondsLeft === 0) {
        return <>{children}</>;
    }
    return (
        <MobilePositionUnavailableStyled onClick={clickAssetScheduleHandler} className={className}>
            <BinIcon name={'IcClock'} size={24} className={'flex-shrink-0'}
                     style={{ fill: 'rgba(255, 255, 255, 0.6)', verticalAlign: 'top' }}/>
            <div className={'d-flex flex-column gap-1'}>
                <span className={'f16 lh24'}>{getLangPath('lite_version.portfolio.inactive_by_schedule')}</span>
                <span className={'d-flex flex-wrap gap-2'}>
                    <span className='subtext'>
                        {getLangPath('lite_version.portfolio.trading_will_start_in')}
                    </span>
                    <span className='subtext time_left'>
                        {intervalsToLocalString(secondsLeft * 1000)}
                    </span>
                </span>
            </div>
        </MobilePositionUnavailableStyled>
    );
};

export default memo(MobilePositionInactiveWrapper);
